//enums to set broker code state from "empty", "unverified", "verificationFailed", "verificationSuccess"
const popEnums = new Map();

popEnums.set('brokerage', 1);
popEnums.set('farmartFee', 2);
popEnums.set('netForPrice', 3);

export default popEnums;
